<div class="public-background bg-gradient-to-br from-white to-primary-500">
  <div class="relative w-full max-w-2xl mx-auto mb-6">
    <a routerLink="/">
      <img src="/assets/qb-logo-dark.svg" alt="QualityBidders" />
    </a>
  </div>
  <div class="relative w-full max-w-2xl p-5 mx-auto bg-white rounded-md shadow-lg pb-7 dark:bg-gray-600 dark:text-gray-50">
    @if (!isConfirmed) {
      @if (!errorMessage) {
        <h1 class="mb-8 text-2xl">Confirming your account...</h1>
        <p class="mb-8">The page will update once your account has been confirmed.</p>
      } @else {
        <h1 class="mb-8 text-2xl">Unable to confirm your account</h1>
        <p class="mb-8">
          {{ errorMessage }}
        </p>
      }
    } @else {
      <h1 class="mb-8 text-2xl">{{ alreadyConfirmed ? 'Your account has already been confirmed.' : 'Your account has been confirmed!' }}</h1>
      <p class="mb-8">Click the button below to navigate to the log in page.</p>
      <div class="text-center">
        <button mat-raised-button color="primary" type="button" routerLink="/login">Go To Login</button>
      </div>
    }
  </div>
</div>
